import cn from 'classnames'
import type { CSSProperties } from 'react'
import React, { useMemo } from 'react'
import HighlighterLib from 'react-highlight-words'

import * as s from './Highlighter.module.scss'

export interface IHighlighterProps {
  text: string
  search?: string
  wordBreak?: CSSProperties['wordBreak']
}

const Highlighter: React.FC<IHighlighterProps> = ({ text, search = '', wordBreak }) => {
  const searchWords = useMemo(() => search.split(/[\s-]/g), [search])

  return (
    <HighlighterLib
      // eslint-disable-next-line react/forbid-component-props
      className={cn(s.root, wordBreak && s[wordBreak])}
      highlightClassName={s.highlight}
      searchWords={searchWords}
      textToHighlight={text}
      autoEscape
    />
  )
}

export default Highlighter
